module.exports = __webpack_public_path__ + "3f1881a1b7c2e26704ced527fce07f94.fbx";